module.exports = __webpack_public_path__ + "img/portraits_02_V.7cbc8bd9.webp";